export default function Logo({ size = 36, className = "", showWordmark = false, wordmarkClassName = "", vertical = false }) {
  return (
    <div className={`flex ${vertical ? "flex-col items-center gap-2" : "items-center gap-2.5"} ${className}`}>
      <img
        src="/logo.jpg"
        alt="Shah"
        width={size}
        height={size}
        className="rounded-md object-cover ring-1 ring-stone-200 shadow-sm"
        style={{ width: size, height: size }}
        data-testid="brand-logo"
      />
      {showWordmark && (
        <span className={`font-medium tracking-[0.18em] ${wordmarkClassName}`}>SHAH</span>
      )}
    </div>
  );
}
